<template>
    <v-expansion-panel>
        <v-expansion-panel-header
            style="background-color: #F2F2F2;"
            class="black--text subtitle-1 font-weight-medium">
            <div class="tooltip-wrap">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            style="display: inline"
                            v-bind="attrs"
                            v-on="on"
                            class="list-tooltip">
                            {{ title }}
                            <v-icon small>mdi-help-rhombus</v-icon>
                        </div>
                    </template>
                    <span>{{ tooltipText('Portal - Income Planner - Annual Savings') }}</span>
                </v-tooltip>
            </div>

        </v-expansion-panel-header>
        <v-expansion-panel-content color="white">
            <v-text-field
                style="margin-top: 20px"
                v-model="form.savingsAccount.value"
                :disabled="disabled"
                prefix="$"
                label="Annual amount to save"
                ></v-text-field>
            <v-select
                v-model="form.savingsAccount.specific_year_to_start"
                :disabled="disabled"
                :items="relativePlanYearOptions"
                label="From plan year"/>
            <v-select
                v-model="form.savingsAccount.specific_year_to_stop"
                :disabled="disabled"
                :items="relativePlanYearOptions"
                label="To plan year"/>
            <v-btn
                :disabled="disabled"
                class="primary text--white"
                @click="() => $emit('annualSavingsUpdated', { payload: form.savingsAccount})">Apply to plan</v-btn>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
export default {
    props: {
        savingsAccount: {
            type: Object,
            default: () => {}
        },
        relativePlanYearDropdown: {
            type: Object,
            required: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        relativePlanYearOptions() {
            let items = []
            for (let year in this.relativePlanYearDropdown) {
                let item = {};
                item.text = this.relativePlanYearDropdown[year];
                item.value = parseInt(year);
                items.push(item);
            }
            return items;
        },
    },

    inject: ['tooltipText'],

    data() {
        return {
            form: {
                savingsAccount: {...this.savingsAccount}
            },
            title: 'Annual Savings'
        }
    }
}
</script>
